import React from "react";
import PropTypes from "prop-types";

import Header from "./header";
import Footer from "./footer";

import "./layout.css";
import styled, { createGlobalStyle } from "styled-components";

import { BrowserRouter as Router } from "react-router-dom";

//Global Style
const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  html, body {
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    /*overflow: auto;*/
  }

  #root {
    width: 100%;  
    display: flex;
    flex-direction: column;
  }

  a {
    text-decoration: none;
    outline: none;
    color: #fff;
  }

  #butterfly-text {
    font-size: 29px;
    color: #fff;
    text-shadow: 2px 2px 6px rgba(15, 15, 15, 0.74);
    border-bottom: 3px solid #f1c40f;
    padding: 10px 3px;
  }

`;

const RootContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const Layout = ({ children }) => (
  <Router>
    <>
      <GlobalStyle />
      <Header />
      <RootContainer>{children}</RootContainer>
      <Footer />
    </>
  </Router>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
